import React from 'react';
import { Switch, Redirect, useRouteMatch } from 'react-router-dom';
import AuthorizedRoute from 'routes/AuthorizedRoute';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';
// eslint-disable-next-line import/extensions
import ConfigList from './submodules/list';
// eslint-disable-next-line import/extensions
import ConfigDetail from './submodules/detail';
// eslint-disable-next-line import/extensions
import ConfigAnalyze from './submodules/analyze';
// eslint-disable-next-line import/extensions
import ConfigHistory from './submodules/history';

const scopes = DASHBOARD_SCOPES[DASHBOARD_RESOURCES.configImpact];

const ConfigImpact: React.FC<{}> = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<AuthorizedRoute
				exact
				configPageName={PAGE_NAMES.dashboard}
				entity={DASHBOARD_RESOURCES.configImpact}
				actions={[scopes?.listKeys]}
				path={`${path}/list`}
				component={ConfigList}
			/>
			<AuthorizedRoute
				exact
				configPageName={PAGE_NAMES.dashboard}
				entity={DASHBOARD_RESOURCES.configImpact}
				actions={[scopes?.viewDetail]}
				path={`${path}/detail/:keyName`}
				component={ConfigDetail}
			/>
			<AuthorizedRoute
				exact
				configPageName={PAGE_NAMES.dashboard}
				entity={DASHBOARD_RESOURCES.configImpact}
				actions={[scopes?.analyzeImpact]}
				path={`${path}/analyze`}
				component={ConfigAnalyze}
			/>
			<AuthorizedRoute
				exact
				configPageName={PAGE_NAMES.dashboard}
				entity={DASHBOARD_RESOURCES.configImpact}
				actions={[scopes?.viewHistory]}
				path={`${path}/history`}
				component={ConfigHistory}
			/>
			<Redirect to={`${path}/list`} />
		</Switch>
	);
};

export default ConfigImpact;
